'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _base2.default)(Object.assign(options, { mapper: defaultMapper }));
};

var _urlMapper = require('url-mapper');

var _urlMapper2 = _interopRequireDefault(_urlMapper);

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultMapper = (0, _urlMapper2.default)({ query: true });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@cerebral/router/lib/index.js
// module id = 282
// module chunks = 0